import { render } from "./StackedBar.vue?vue&type=template&id=ba88fcec&scoped=true"
import script from "./StackedBar.vue?vue&type=script&lang=js"
export * from "./StackedBar.vue?vue&type=script&lang=js"

import "./StackedBar.vue?vue&type=style&index=0&id=ba88fcec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba88fcec"]])

export default __exports__